import PropTypes from 'prop-types';
import BatchScheduleHeader from './BatchScheduleHeader';
import BatchScheduleWrapper from './BatchScheduleWrapper';

const BatchSchedule = ({ batchUID }) => {
  return (
    <>
      <BatchScheduleHeader batchUID={batchUID} />
      <BatchScheduleWrapper batchUID={batchUID} />
    </>
  );
};

export default BatchSchedule;

BatchSchedule.propTypes = {
  batchUID: PropTypes.string.isRequired
};
